import { Component, Input, ViewContainerRef } from '@angular/core';
import { SectionHeaderComponent } from '../../../../../common/section-header/section-header.component';
import { DynamicFormComponent } from '../../../../../dynamic-form/dynamic-form.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OperationService } from '../../../../../../services/operations.service';
import { DynamicFormService } from '../../../../../../services/dynamic-form.service';
import { InventoryService } from '../../../../../../services/inventory-service';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingService } from '../../../../../../services/loading.service';
import { ToasterService } from '../../../../../../services/toaster.service';
import { EditableTableComponent } from '../../../../../editable-table-v2/editable-table.component';
import { Container } from '../../../../../../models/container.interface';
import { InventoryType, PageAction } from '../../../../../../constants/app-constants';
import { convertEpochToISTDateTime } from '../../../../../../utils/date-time-utils';
import { JobOrderFormActions } from '../../job-order-renderer/job-order-renderer.component';
import { StaticTableComponent } from '../../../../../static-table/static-table.component';
import { AutocompleteDropdownComponent } from '../../../../../autocomplete-dropdown/autocomplete-dropdown.component';
import { SvgIconComponent } from '../../../../../svg-icon/svg-icon.component';
import { SharedModule } from '../../../../../../modules/shared/shared.module';
import { Customer } from '../../../../../../models/customer-master.interface';
import { FilterCondition } from '../../../../../../models/table-list-request.interface';
import { finalize, firstValueFrom, forkJoin, Observable, of, switchMap } from 'rxjs';
import { JOShippingBill } from '../../../../../../models/shipping-bill.interface';
import { InventoryDetails, JobOrderAdditionalInfo, JobOrderInventory, JobOrderVendorService, PackageDetails } from '../../../../../../models/job-orders.interface';
import { RightPanelComponent } from '../../../../../right-panel/right-panel.component';
import { ManageInventoryServiceComponent } from '../../common/manage-inventory-service/manage-inventory-service.component';
import { EditableGridFormComponent } from '../../../../../editable-grid-form/editable-grid-form.component';
import { EditableTableMeta } from '../../../../../../models/editable-table-header.interface';
import { CommonUtils } from '../../../../../../utils/common-utils';
import { JobOrderDetails } from '../../../../../../models/job-order-details.interface';
import { CargoItem } from '../../../../../../models/cargo-item.interface';
import { APIResponse } from '../../../../../../models/standard-response.interface';
import { CargoService } from '../../../../../../services/inventory/cargo.service';
import { IdName } from '../../../../../../models/id-name.interface';
import { JobOrderService } from '../../../../../../services/job.order.service';
import { ServiceType } from '../../../../../../constants/master-constants';

@Component({
  selector: 'app-export-stuffing',
  standalone: true,
  imports: [SectionHeaderComponent,
    DynamicFormComponent,
    EditableTableComponent,
    StaticTableComponent,
    AutocompleteDropdownComponent,
    SvgIconComponent,
    SharedModule
  ],
  templateUrl: './export-stuffing.component.html',
  styleUrl: './export-stuffing.component.scss',
  providers: [DatePipe]
})
export class ExportStuffingComponent implements JobOrderFormActions {
  @Input() processCycle!: string;
  @Input() jobOrderType!: string;
  @Input() jobOrderId!: string;
  @Input() jobOrderConfig!: any;

  jobOrderForm!: FormGroup;
  mode = PageAction.INSERT;

  itemList: any[] = [];
  containerList: Container[] = [];
  selectedItem: any = null;
  selectedContainer: Container | null = null;
  selectedCustomer!: IdName;
  addedInventorySet: Set<string> = new Set();

  searchItemText: string = '';
  searchContainerText: string = '';
  disableItemAddButton: boolean = true;
  disableContainerAddButton: boolean = true;
  shippingBillOptions: {label: string, value: string } [] = [];

  private vendorMap: Map<string, JobOrderVendorService[]> = new Map();
  private loadPlanMap: Map<string, InventoryDetails[]> = new Map();
  private initialInventoryMap: Map<string, string> = new Map();
  private initialVendorIds: Set<string> = new Set();

  containerLoadPlanConfig!: EditableTableMeta;

  cargoFilters: FilterCondition[] = [
    {
      "name": "DOCUMENT_TYPE_EQUALS",
      "alias": "documentType",
      "value": ["SHIPPING_BILL"]
    },
    {
      "name": "ACCOUNT_HOLDER_EQUALS",
      "alias": "accountHolder",
      "value": [""]
    }
  ];

  containerFilters: FilterCondition[] = [
    {
      "name": "IS_GATED_IN",
      "alias": "gatedIn",
      "value": ["true"]
    },
    {
      "name": "IS_EMPTY",
      "alias": "empty",
      "value": ["true"]
    },
    {
      "name": "ACCOUNT_HOLDER_EQUALS",
      "alias": "accountHolder",
      "value": [""]
    },
  ];

  constructor(
    private dynamicFormService: DynamicFormService,
    private fb: FormBuilder,
    private api: OperationService,
    private inventoryService: InventoryService,
    private toasterService: ToasterService,
    private loadingService: LoadingService,
    private operationService: OperationService,
    private jobOrderService: JobOrderService,
    private cargoService: CargoService,
    private router: Router,
    private route: ActivatedRoute,
    private viewContainerRef: ViewContainerRef,
    private datePipe: DatePipe
  ) {
    this.jobOrderForm = fb.group({
      itemDetails: this.fb.array([])
    });
  }

  ngOnInit() {
    this.dynamicFormService.addControlsToForm(this.jobOrderForm, this.jobOrderConfig.jobOrderFormElements);
    this.containerLoadPlanConfig = JSON.parse(JSON.stringify(this.jobOrderConfig.containerLoadPlanConfig)) as EditableTableMeta;
    this.setComponentMode();
    this.loadJobOrderData();
    this.setFormValues();
  }

  setComponentMode() {
    if (this.jobOrderId === "") {
      return;
    }

    if (this.route.snapshot.url[0].path === "edit") {
      this.mode = PageAction.UPDATE;
    } else {
      this.mode = PageAction.VIEW;
    }
  }

  get isViewMode() : boolean {
    return this.mode == PageAction.VIEW;
  }

  setFormValues() {
    if (this.mode === PageAction.INSERT) {
      this.jobOrderForm.get("issueDate")?.setValue(convertEpochToISTDateTime(new Date().getTime()));
    } else if (this.mode === PageAction.UPDATE) {
      this.jobOrderForm.get("accountHolder")?.disable();
    }
  }

  handleFormValueChange(event: {controlName: string, result: any}) {
    if (event.controlName === "accountHolder") {
      const customer = event.result as Customer;
      this.selectedCustomer = {id: customer.id, name: customer.name};
      this.addCustomerToTheSearchFilter(customer.id);
    }
  }

  onSearchTextCleared(controlName: string) {
    if (controlName === "accountHolder") {
      this.resetOnCustomerChange();
    }
  }

  handleContainerInlineAction(event: { actionName: string, index: number }) {
    const container = this.containerList[event.index];
    if (event.actionName === "manage-service") {
      this.manageServices(container.id!)
    } else if (event.actionName === "container-load-plan") {
      this.manageContainerLoadPlan(container.id!)
    }
  }

  onContainerSelected(container: Container) {
    if (this.selectedCustomer) {
      this.selectedContainer = container;
      this.disableContainerAddButton = false;
    } else {
      this.toasterService.error("Select the customer");
      this.resetContainerSelection();
    }
  }

  addContainer() {
    if (this.selectedContainer && !this.addedInventorySet.has(this.selectedContainer.id)) {
      this.containerList.push(this.selectedContainer);
      this.addedInventorySet.add(this.selectedContainer.id);
    } else {
      this.toasterService.info("Container is already added");
    }
    this.disableContainerAddButton = true;
  }

  onItemSelected(cargo: any) {
    if (this.selectedCustomer) {
      this.selectedItem = cargo;
      this.disableItemAddButton = false;
    } else {
      this.toasterService.error("Select the customer");
      this.resetCargoSelection();
    }
  }

  configureServices() {
    const inventoryOptions = this.containerList.map((item: Container) => ({key: item.id, value: item.containerNo}));
    this.jobOrderService.openServicePanel(
      this.viewContainerRef,
      inventoryOptions,
      InventoryType.CONTAINER,
      ServiceType.GENERAL_SERVICE,
      null,
      (service, ids) => {
        this.jobOrderService.addServiceToInventory(this.vendorMap, this.containerList, service, ids, InventoryType.CONTAINER);
      }
    );
  }

  manageServices(inventoryId: string) {
    const rightPanelComponentRef = this.viewContainerRef.createComponent(RightPanelComponent);
    rightPanelComponentRef.instance.title = "Manage Service";
    rightPanelComponentRef.instance.hidePrimaryButton = true;
    rightPanelComponentRef.instance.showActionBtns = true;
    rightPanelComponentRef.instance.secondaryActionBtnText = "Close";
    
    if (!this.vendorMap.has(inventoryId)) {
      this.vendorMap.set(inventoryId, []);
    }

    const manageAttributeRef = rightPanelComponentRef.instance.loadComponent(ManageInventoryServiceComponent);
    manageAttributeRef.setInput("serviceList", this.vendorMap.get(inventoryId));
    manageAttributeRef.setInput("inventoryType", InventoryType.CONTAINER);
    manageAttributeRef.setInput("parentViewContainerRef", this.viewContainerRef);
    manageAttributeRef.setInput("readonly", this.isViewMode);

    rightPanelComponentRef.instance.close.subscribe(() => {
      manageAttributeRef.instance.publishUpdatedList();
    })

    manageAttributeRef.instance.serviceListListener.subscribe((jobOrderVendorService: JobOrderVendorService[]) => {
      this.vendorMap.set(inventoryId, jobOrderVendorService);
      rightPanelComponentRef.destroy();
    });
  }

  manageContainerLoadPlan(inventoryId: string) {
    const rightPanelComponentRef = this.viewContainerRef.createComponent(RightPanelComponent);
    rightPanelComponentRef.instance.title = "Manage Trucks";
    rightPanelComponentRef.instance.hidePrimaryButton = false;
    rightPanelComponentRef.instance.showActionBtns = true;
    rightPanelComponentRef.instance.secondaryActionBtnText = "Cancel";
    

    const tableData = this.loadPlanMap.get(inventoryId) ?? [];
    const gridFormComponentRef = rightPanelComponentRef.instance.loadComponent(EditableGridFormComponent);

    const column = this.containerLoadPlanConfig.columns.find((column) => column.fieldName === "inventoryId");
    
    if (column?.properties) {
      column.properties.options = this.shippingBillOptions;
    }

    gridFormComponentRef.setInput("tableConfig", this.containerLoadPlanConfig);
    gridFormComponentRef.setInput("tableData", JSON.parse(JSON.stringify(tableData)));
    gridFormComponentRef.setInput("disable", this.isViewMode);

    rightPanelComponentRef.instance.primaryActionBtnEmitter.subscribe(() => {
      gridFormComponentRef.instance.publishUpdatedList();
    });

    rightPanelComponentRef.instance.close.subscribe(() => {
      rightPanelComponentRef.destroy();
    });

    gridFormComponentRef.instance.publish.subscribe((itemList: InventoryDetails[]) => {
      if (!this.isValidContainerLoadPlan(inventoryId, itemList)) {
        return;
      }
      this.loadPlanMap.set(inventoryId, itemList);
      rightPanelComponentRef.destroy();
    });
  }

  cancel(): void {
    this.goBack();
  }

  goBack(): void {
    this.router.navigateByUrl("/manage-operations/import/job-orders");
  }

  saveForm(): void{
    this.jobOrderForm.markAllAsTouched();
    const jobOrderRequest = this.createJobOrderRequest();
    const jobOrder$ = this.mode == PageAction.UPDATE
                      ? this.operationService.updateJobOrder(this.jobOrderId, jobOrderRequest)
                      : this.operationService.saveJobOrder(jobOrderRequest);

    jobOrder$.subscribe({
      next: (response) => {
        this.toasterService.success("Successfully " + this.mode == PageAction.UPDATE ? "updated" : "created" + " the job order");
        this.goBack();
      },
      error: (error) => {
        console.log("Request failed:", error);
        this.toasterService.error(error.error.errorDesc);
      }
    });
  }

  private createJobOrderRequest(): any {
    const jobOrderInventoryList: JobOrderInventory[] = this.createJobOrderInventory();
    const deletedJobOrderVendorIds = this.getDeletedVendorIds();
    const jobOrderAdditionalInfo: JobOrderAdditionalInfo = {
      accountHolder: this.selectedCustomer
    }

    return {
      jobOrderType: this.jobOrderType,
      jobOrderAdditionalInfo,
      operationalProcess: this.processCycle,
      expiryDate: new Date(this.jobOrderForm.get("expiryDate")?.value).getTime(),
      jobOrderInventoryList,
      deletedJobOrderVendorIds
    };
  }

  loadJobOrderData() {
    if (this.mode === PageAction.INSERT) return;
    
    this.loadingService.show();
    this.operationService.getJobOrderByIdLite(this.jobOrderId).pipe(
      switchMap((response: any) => {
        const jobOrderData = response?.data;
  
        const cargoIds = jobOrderData.jobOrderInventoryList
          .filter((inv: any) => inv.inventoryType === "CARGO")
          .map((inv: any) => inv.inventoryId);
        
        const containerIds = jobOrderData.jobOrderInventoryList
        .filter((inv: any) => inv.inventoryType === "CONTAINER")
        .map((inv: any) => inv.inventoryId);

          const forkJoinPayload: {
            jobOrder: Observable<JobOrderDetails>,
            cargoResponse?: Observable<APIResponse>,
            containerResponse?: Observable<APIResponse>
          } = {
            jobOrder: of(jobOrderData)
          };

          if (cargoIds.length) {
            forkJoinPayload.cargoResponse = this.inventoryService.listShippingBill(CommonUtils.buildIdFilterRequest(cargoIds));
          }

          if (containerIds.length) {
            forkJoinPayload.containerResponse = this.inventoryService.getContainerList(CommonUtils.buildIdFilterRequest(containerIds));
          }

          return forkJoin(forkJoinPayload);
      }),
      finalize(() => this.loadingService.hide())
    ).subscribe({
      next: (result: { jobOrder: JobOrderDetails; cargoResponse?: APIResponse; containerResponse?: APIResponse }) => {
        const cargos = result.cargoResponse?.data?.records ?? [];
        const containers = result.containerResponse?.data?.records ?? [];
        this.hydrateForm(result.jobOrder, cargos, containers);
      },
      error: (error) => {
        console.error(error);
        this.toasterService.error("Failed to get job order data");
      }
    });
  }


  hydrateForm(jobOrderData: JobOrderDetails, cargos: CargoItem[], containers: Container[]) {
    const inventoryMap = new Map<string, JobOrderInventory>();

    for (const inventory of jobOrderData.jobOrderInventoryList as JobOrderInventory[]) {
      
      const { inventoryId, joInvId, inventoryType, inventoryNo, additionalDetails, jobOrderServiceList } = inventory;

      if (!inventoryId) continue;

      inventoryMap.set(inventoryId, inventory);
      this.addedInventorySet.add(inventoryId);

      if (joInvId) {
        this.initialInventoryMap.set(inventoryId, joInvId);
      }

      if (inventoryType === "CONTAINER") {
        this.loadPlanMap.set(inventoryId, additionalDetails?.associatedItems ?? []);
      }

      if (inventoryType === "CARGO") {
        this.shippingBillOptions.push({ label: inventoryNo, value: inventoryId });
      }

      if (jobOrderServiceList?.length) {
        this.vendorMap.set(inventoryId, jobOrderServiceList);
        jobOrderServiceList.forEach(service => {
          if (service.id) this.initialVendorIds.add(service.id);
        });
      }
    }

    // === Transform CargoItems into ShippingBills with JO metadata ===
    this.itemList = cargos.map((bill) => {
      const sb = this.cargoService.transformToShippingBill(bill);
      const joInv = inventoryMap.get(sb.id ?? '');
      return {
        ...sb,
        joNop: joInv?.additionalDetails?.joNop ?? 0,
        joWeight: joInv?.additionalDetails?.joWeight ?? 0,
        joVolume: joInv?.additionalDetails?.joVolume ?? 0
      };
    });

    this.containerList = containers;

    // === Set Account Holder ===
    const accountHolder = jobOrderData.additionalDetails?.accountHolder;
    if (accountHolder?.id) {
      this.selectedCustomer = accountHolder;
      this.addCustomerToTheSearchFilter(this.selectedCustomer.id);
    }

    // === Patch Form ===
    this.jobOrderForm.patchValue({
      ...jobOrderData,
      ...jobOrderData?.additionalDetails,
      accountHolder: {key: this.selectedCustomer.id, value: this.selectedCustomer.name},
      expiryDate: convertEpochToISTDateTime(jobOrderData?.expiryDate),
      issueDate: convertEpochToISTDateTime(jobOrderData?.issueDate)
    });


    if (this.isViewMode) {
      this.jobOrderForm.disable();
    }
  }

  createJobOrderInventory(): JobOrderInventory[] {
    const itemInventories = (this.itemList ?? []).map((cargo: JOShippingBill) => ({
      joInvId: this.initialInventoryMap.get(cargo.id!),
      inventoryId: cargo.id!,
      inventoryNo: cargo.documentNo,
      inventoryType: 'CARGO',
    }));

    const containerInventories = this.containerList.map((container) => {
      const containerId = container.id;
      const containerData: JobOrderInventory = {
        joInvId: this.initialInventoryMap.get(containerId),
        inventoryId: containerId,
        inventoryNo: container.containerNo,
        inventoryType: 'CONTAINER',
        additionalDetails: {
          associatedItems: this.loadPlanMap.get(containerId)
        },
        jobOrderServiceList: this.vendorMap.get(containerId)
      };
      return containerData;
    });


    return [...containerInventories, ...itemInventories];
  }

  getDeletedVendorIds(): string[] {
    const currentVendorIds = new Set<string>();
    this.vendorMap.forEach((vendors) => {
      vendors.forEach((vendor: JobOrderVendorService) => {
        if (vendor.id) {
          currentVendorIds.add(vendor.id);
        }
      });
    });

    const deletedVendorIds: string[] = [];
    this.initialVendorIds.forEach((jovId) => {
      if (!currentVendorIds.has(jovId)) {
        deletedVendorIds.push(jovId);
      }
    });

    return deletedVendorIds;
  }

  async addItem() {
    if (this.selectedItem && !this.addedInventorySet.has(this.selectedItem.id)) {
      const itemId = this.selectedItem.id;
      this.loadingService.show();
      try {
        const selectedItemDetails = await firstValueFrom(this.inventoryService.fetchShippingBillById(itemId));
        const shippingBill = selectedItemDetails.data as JOShippingBill;
        this.itemList.push(shippingBill);
        this.addedInventorySet.add(itemId);
        this.shippingBillOptions.push({label: shippingBill.documentNo, value: shippingBill.id!});
      } catch (err) {
        console.error('Error fetching item details:', err);
        this.toasterService.error('Failed to fetch item details');
      } finally {
        this.loadingService.hide();
      }
    } else {
      this.toasterService.info("Shipping Bill is already added");
    }
    this.resetCargoSelection();
  }

  private addCustomerToTheSearchFilter(customerId: string) {
    console.log(customerId);
    const accHolderFilter = this.cargoFilters.find((filter) => filter.name === 'ACCOUNT_HOLDER_EQUALS');
    if (accHolderFilter) 
      accHolderFilter.value = [customerId];

    const containerAccHolderFilter = this.containerFilters.find((filter) => filter.name === 'ACCOUNT_HOLDER_EQUALS');
    if (containerAccHolderFilter) 
      containerAccHolderFilter.value = [customerId];

    console.log(accHolderFilter);
    console.log(containerAccHolderFilter);
  }

  private isValidContainerLoadPlan(inventoryId: string, itemDetails: InventoryDetails[]): boolean {
    const shippingBillMap = new Map<string, JOShippingBill>(
      this.itemList.map(cargo => [cargo.id, cargo])
    );
    const totalAssignedMap = new Map<string, PackageDetails>();

    for (const [containerId, cargoList] of this.loadPlanMap.entries()) {
      if (containerId === inventoryId) continue; // skip the current one
      for (const { inventoryId: cargoId, nop, weight, volume } of cargoList) {
        const current = totalAssignedMap.get(cargoId!);
        totalAssignedMap.set(cargoId!, {nop: current?.nop ?? 0 + (Number(nop) || 0), weight: current?.weight ?? 0 + (Number(weight) || 0), volume: current?.volume ?? 0 + (Number(volume) || 0) });
      }
    }

    for (const [index, item] of itemDetails.entries()) {
      const {inventoryId, nop, weight, volume} = item;
      
      if (!inventoryId || !inventoryId.trim()) {
        this.toasterService.error(`Row ${index + 1}: Shipping Bill is required.`);
        return false;
      }

      item.inventoryNo = shippingBillMap.get(inventoryId)?.documentNo ?? '';
      const current = totalAssignedMap.get(inventoryId);
      totalAssignedMap.set(item.inventoryId!, {nop: current?.nop ?? 0 + (Number(nop) || 0), weight: current?.weight ?? 0 + (Number(weight) || 0), volume: current?.volume ?? 0 + (Number(volume) || 0) });
    }

    for (const [cargoId, totalAssigned] of totalAssignedMap.entries()) {
      const allowedPackages = shippingBillMap.get(cargoId);
      const cargo = this.itemList.find(c => (c.id ?? c.inventoryId) === cargoId);
      const cargoName = cargo?.documentNo;
      if (totalAssigned.nop > (allowedPackages?.joNop ?? 0)) {
        this.toasterService.error(`Cargo ${cargoName} is assigned ${totalAssigned.nop} packages, exceeding allowed ${allowedPackages?.joNop}.`);
        return false;
      }
      if (totalAssigned.weight > (allowedPackages?.joWeight ?? 0)) {
        this.toasterService.error(`Cargo ${cargoName} is assigned ${totalAssigned.weight} packages, exceeding allowed ${allowedPackages?.joWeight}.`);
        return false;
      }
      if (totalAssigned.volume > (allowedPackages?.joVolume ?? 0)) {
        this.toasterService.error(`Cargo ${cargoName} is assigned ${totalAssigned.volume} packages, exceeding allowed ${allowedPackages?.joVolume}.`);
        return false;
      }
    }
    return true;
  }

  private resetCargoSelection(): void {
    this.searchItemText = '';
    this.disableItemAddButton = true;
    this.selectedItem = null;
  }

  private resetContainerSelection(): void {
    this.searchContainerText = '';
    this.disableContainerAddButton = true;
    this.selectedContainer = null;
  }

  private resetOnCustomerChange (): void {
    this.itemList = [];
    this.containerList = [];
    this.vendorMap.clear();
    this.loadPlanMap.clear();
  }
}
